export enum SoleTraderDecisionQuestion {
  Q_152 = "152", // Will your business activities be carried out in Australia?
  Q_139 = "139", // Have you started business or are you taking steps to begin trading?
  Q_3 = "3", // What is the nature of your business?
  Q_143 = "143", // Are you carrying out activities that show you're starting or running a business?
  Q_156 = "156", // Are you making supplies connected to the Indirect Tax Zone?
  Q_135 = "135", // Are you applying for a 'GST Only' registration?
  Q_5 = "5", // Are you renting out residential property on a regular or continuous basis?
  Q_6 = "6", // Do your business activities take place on a regular or continuous basis?
  Q_147 = "147", // Do you expect to make a profit or gain from your activity?
}

export const SOLE_TRADER_DECISION_FIELD_TO_PATH: Record<SoleTraderDecisionQuestion, string> = {
  [SoleTraderDecisionQuestion.Q_152]: "business-in-australia",
  [SoleTraderDecisionQuestion.Q_139]: "started-business",
  [SoleTraderDecisionQuestion.Q_3]: "business-nature",
  [SoleTraderDecisionQuestion.Q_143]: "business-activities",
  [SoleTraderDecisionQuestion.Q_156]: "indirect-tax-zone",
  [SoleTraderDecisionQuestion.Q_135]: "gst-only",
  [SoleTraderDecisionQuestion.Q_5]: "residential-property",
  [SoleTraderDecisionQuestion.Q_6]: "regular-business",
  [SoleTraderDecisionQuestion.Q_147]: "profit-expectation",
};

export interface AnswerTrailEntry {
  answerId: string;
  questionId: string;
  nextQuestionId: string;
}
